import _ from 'underscore'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Metrics from 'pages/MaintenanceTrends/Metrics'
import Groups from 'pages/MaintenanceTrends/Groups'
import Trends from 'pages/MaintenanceTrends/Trends'

import Tabs, { Tab } from 'components/Tabs'

import useDeviceMetrics from 'hooks/useDeviceMetrics'

import { PageHeader, PageTitle, screenSize, SinglePanePage } from 'styles/shared'

const TABS = [
  { header: 'Metrics', detailsComponent: Metrics },
  { header: 'Groups', detailsComponent: Groups },
  { header: 'Trends', detailsComponent: Trends }
]

const MaintenanceTrends = () => {
  useDeviceMetrics()

  const location = useLocation()
  const navigate = useNavigate()
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const pathname = location.pathname

  useEffect(() => {
    if (pathname.includes('trends')) {
      setActiveTabIndex(2)
    } else if (pathname.includes('groups')) {
      setActiveTabIndex(1)
    } else if (pathname.includes('metrics')) {
      setActiveTabIndex(0)
    }
  }, [pathname])

  const onTabChange = (index) => {
    setActiveTabIndex(index)

    navigate(`/admin/${TABS[index].header.toLowerCase()}`)
  }

  return (
    <>
      <PageHeader>
        <PageTitle>Maintenance Trends</PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <Tabs
          tabpage="others"
          activeTabIndex={activeTabIndex}
          onSelectTabIndexCallback={(index) => onTabChange(index)}
        tabItems={
          _.map(TABS, r => {
            const item: Tab = {
              key: r.header,
              header: <S.Header>{r.header}</S.Header>,
              details: <r.detailsComponent />
            }

            return item
          })
        }
        />
      </S.SinglePanePage>
    </>
  )
}

const S = {
  Header: styled.div`
    display: flex;
    justify-content: space-between;

    @media ${screenSize.small} {
      justify-content: flex-end;
    }
  `,
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0px;
    }
  `
}

export default MaintenanceTrends
